import UnauthenticatedOnlyRoute from './UnauthenticatedOnlyRoute';

export default UnauthenticatedOnlyRoute;
